// ** MUI Imports
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

// ** Hook Import

const ReactHotToast = styled(Box)(({ theme }) => {
  // ** Hook & Var


  return {
    '& > div': {
      left: `${theme.spacing(6)} !important`,
      right: `${theme.spacing(6)} !important`,
      bottom: `${theme.spacing(6)} !important`,
      top:  '139px !important',
      // zIndex: useMediaQuery(theme.breakpoints.down('lg'))
      //   ? `${theme.zIndex.drawer + 1} !important`
      //   : `${theme.zIndex.drawer + 1} !important`
      zIndex: 100000
    },
    '& .react-hot-toast': {
      fontWeight: 400,
      letterSpacing: '0.14px',
      boxShadow: theme.shadows[4],
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      fontSize: theme.typography.body1.fontSize,
      background: theme.palette.background.paper,
      '&>:first-of-type:not([role])>:first-of-type': {
        width: 14,
        height: 14
      }
    }
  }
})

export default ReactHotToast
